import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Shield, Calendar, ArrowRight, Trash2 } from 'lucide-react';

export const AssignationsViews = ({ viewMode, filteredAssignments, assignmentsByAdmin, getTypeConfig, onDelete }) => {
  if (viewMode === 'cards') {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {filteredAssignments.map((assignment) => {
            const typeConfig = getTypeConfig(assignment.assigned_user_type);
            const TypeIcon = typeConfig.icon;
            
            return (
              <Card key={assignment.id} className="hover:shadow-lg transition-shadow">
                <CardContent className="pt-5">
                  {/* Header avec type */}
                  <div className="flex items-center justify-between mb-4">
                    <Badge className={`${typeConfig.color} text-white`}>
                      <TypeIcon className="h-3 w-3 mr-1" />
                      {typeConfig.label}
                    </Badge>
                    <div className="flex items-center text-xs text-gray-500">
                      <Calendar className="h-3 w-3 mr-1" />
                      {new Date(assignment.assigned_at).toLocaleDateString('fr-FR')}
                    </div>
                  </div>
                  
                  {/* Assignation visuelle */}
                  <div className="flex items-center gap-3">
                    {/* Admin */}
                    <div className="flex-1 text-center">
                      <div className="w-12 h-12 rounded-full bg-orange-100 flex items-center justify-center mx-auto mb-2">
                        <Shield className="h-6 w-6 text-orange-600" />
                      </div>
                      <p className="font-medium text-sm truncate">
                        {assignment.admin_prenom} {assignment.admin_nom}
                      </p>
                      <p className="text-xs text-gray-500">Admin</p>
                    </div>
                    
                    {/* Flèche */}
                    <ArrowRight className="h-5 w-5 text-gray-400 flex-shrink-0" />
                    
                    {/* Utilisateur assigné */}
                    <div className="flex-1 text-center">
                      <div className={`w-12 h-12 rounded-full ${typeConfig.bgLight} flex items-center justify-center mx-auto mb-2`}>
                        <TypeIcon className={`h-6 w-6 ${typeConfig.textColor}`} />
                      </div>
                      <p className="font-medium text-sm truncate">
                        {assignment.assigned_user_prenom} {assignment.assigned_user_nom}
                      </p>
                      <p className="text-xs text-gray-500">{typeConfig.label}</p>
                    </div>
                  </div>
                  
                  {/* Actions */}
                  <div className="flex justify-end gap-2 mt-4 pt-3 border-t">
                    <Button
                      variant="ghost"
                      size="sm"
                      className="text-red-600 hover:bg-red-50"
                      onClick={() => onDelete(assignment.id)}
                    >
                      <Trash2 className="h-4 w-4" />
                    </Button>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
    );
  }
  if (viewMode === 'table') {
    return (
        <Card>
          <CardContent className="p-0">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50 border-b">
                  <tr>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Administrateur</th>
                    <th className="px-4 py-3 text-center text-sm font-semibold text-gray-700"></th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Utilisateur assigné</th>
                    <th className="px-4 py-3 text-center text-sm font-semibold text-gray-700">Type</th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Date</th>
                    <th className="px-4 py-3 text-right text-sm font-semibold text-gray-700">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  {filteredAssignments.map((assignment) => {
                    const typeConfig = getTypeConfig(assignment.assigned_user_type);
                    const TypeIcon = typeConfig.icon;
                    
                    return (
                      <tr key={assignment.id} className="hover:bg-gray-50">
                        <td className="px-4 py-3">
                          <div className="flex items-center gap-3">
                            <div className="w-8 h-8 rounded-full bg-orange-100 flex items-center justify-center">
                              <Shield className="h-4 w-4 text-orange-600" />
                            </div>
                            <div>
                              <p className="font-medium">{assignment.admin_prenom} {assignment.admin_nom}</p>
                              <p className="text-xs text-gray-500">{assignment.admin_email}</p>
                            </div>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-center">
                          <ArrowRight className="h-4 w-4 text-gray-400 mx-auto" />
                        </td>
                        <td className="px-4 py-3">
                          <div className="flex items-center gap-3">
                            <div className={`w-8 h-8 rounded-full ${typeConfig.bgLight} flex items-center justify-center`}>
                              <TypeIcon className={`h-4 w-4 ${typeConfig.textColor}`} />
                            </div>
                            <div>
                              <p className="font-medium">
                                {assignment.assigned_user_prenom} {assignment.assigned_user_nom}
                              </p>
                              <p className="text-xs text-gray-500">{assignment.assigned_user_email}</p>
                            </div>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-center">
                          <Badge className={`${typeConfig.color} text-white`}>
                            {typeConfig.label}
                          </Badge>
                        </td>
                        <td className="px-4 py-3">
                          <div className="flex items-center gap-1 text-sm text-gray-600">
                            <Calendar className="h-4 w-4" />
                            {new Date(assignment.assigned_at).toLocaleDateString('fr-FR')}
                          </div>
                        </td>
                        <td className="px-4 py-3 text-right">
                          <Button
                            variant="ghost"
                            size="sm"
                            className="text-red-600 hover:bg-red-50"
                            onClick={() => onDelete(assignment.id)}
                          >
                            <Trash2 className="h-4 w-4" />
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </CardContent>
        </Card>
    );
  }
  return (
        <div className="space-y-6">
          {assignmentsByAdmin.map((group) => (
            <Card key={group.admin.id}>
              <CardHeader className="pb-3 bg-gradient-to-r from-orange-50 to-white">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-full bg-orange-100 flex items-center justify-center">
                      <Shield className="h-6 w-6 text-orange-600" />
                    </div>
                    <div>
                      <CardTitle className="text-lg">
                        {group.admin.prenom} {group.admin.nom}
                      </CardTitle>
                      <p className="text-sm text-gray-500">{group.admin.email}</p>
                    </div>
                  </div>
                  <Badge className="bg-indigo-800 text-white text-lg px-3 py-1 font-medium">
                    {group.assignments.length} assigné(s)
                  </Badge>
                </div>
              </CardHeader>
              <CardContent className="pt-4">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                  {group.assignments.map((assignment) => {
                    const typeConfig = getTypeConfig(assignment.assigned_user_type);
                    const TypeIcon = typeConfig.icon;
                    
                    return (
                      <div 
                        key={assignment.id} 
                        className={`flex items-center gap-3 p-3 rounded-lg border ${typeConfig.bgLight} border-opacity-50`}
                      >
                        <div className={`w-10 h-10 rounded-full bg-white flex items-center justify-center shadow-sm`}>
                          <TypeIcon className={`h-5 w-5 ${typeConfig.textColor}`} />
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="font-medium text-sm truncate">
                            {assignment.assigned_user_prenom} {assignment.assigned_user_nom}
                          </p>
                          <p className="text-xs text-gray-500">{typeConfig.label}</p>
                        </div>
                        <Button
                          variant="ghost"
                          size="sm"
                          className="text-red-500 hover:bg-red-100"
                          onClick={() => onDelete(assignment.id)}
                        >
                          <Trash2 className="h-3 w-3" />
                        </Button>
                      </div>
                    );
                  })}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
  );
};
